import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { mockData } from "../mock";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { navigation } = mockData;

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? "bg-white/95 backdrop-blur-sm shadow-lg border-b border-gray-100" 
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Clickable Home Link */}
          <div className="flex items-center">
            <a href="/" className="flex items-center hover:opacity-80 transition-all duration-300 hover:scale-105">
              <img 
                src="https://customer-assets.emergentagent.com/job_premier-b2b-site/artifacts/4ivcj81e_Logo.svg"
                alt="CNESS Logo - Home"
                className="h-14 w-auto cursor-pointer filter drop-shadow-lg"
                style={{
                  filter: isScrolled 
                    ? "drop-shadow(2px 2px 4px rgba(0,0,0,0.1))" 
                    : "drop-shadow(2px 2px 6px rgba(0,0,0,0.3)) brightness(1.1) contrast(1.1)"
                }}
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.items.filter(item => !item.type).map((item) => (
              <a
                key={item.label}
                href={item.url}
                className={`font-medium transition-colors hover:text-amber-500 ${
                  isScrolled ? "text-gray-900" : "text-white"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA Buttons - Always Visible */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="/login"
              className={`font-medium transition-colors hover:text-amber-500 ${
                isScrolled ? "text-gray-900" : "text-white"
              }`}
            >
              Login
            </a>
            <a href="/signup">
              <Button className="bg-gradient-to-r from-amber-500 to-amber-600 text-white hover:from-amber-600 hover:to-amber-700 shadow-lg hover:shadow-xl transition-all duration-300">
                Sign Up
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className={`lg:hidden ${
                  isScrolled ? "text-gray-700" : "text-white"
                }`}
              >
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-white">
              <nav className="flex flex-col space-y-6 mt-8">
                {navigation.items.map((item) => (
                  <a
                    key={item.label}
                    href={item.url}
                    className="text-gray-700 font-medium text-lg hover:text-amber-600 transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ))}
                <div className="pt-6 border-t border-gray-200 space-y-4">
                  <a href="/login">
                    <Button variant="outline" className="w-full">
                      Login
                    </Button>
                  </a>
                  <Button className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white">
                    Sign Up
                  </Button>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;